import { apiClient } from './api-client';
import {
  PortfolioProperty,
  PortfolioListResponse,
  PortfolioSummary,
  PortfolioPropertyFormData,
  PortfolioSimulation,
  SimulationParameters,
  EnrichedSimulation,
} from '@/types/index';

export const portfolioService = {
  getAll: (): Promise<PortfolioListResponse> =>
    apiClient.get<PortfolioListResponse>('/portfolio'),

  getAllSimulations: (): Promise<EnrichedSimulation[]> =>
    apiClient.get<EnrichedSimulation[]>('/portfolio/all-simulations'),

  getById: (id: string): Promise<PortfolioProperty> =>
    apiClient.get<PortfolioProperty>(`/portfolio/${id}`),

  getSummary: (): Promise<PortfolioSummary> =>
    apiClient.get<PortfolioSummary>('/portfolio/summary'),

  create: (data: PortfolioPropertyFormData): Promise<PortfolioProperty> =>
    apiClient.post<PortfolioProperty>('/portfolio', data),

  update: (id: string, data: Partial<PortfolioPropertyFormData>): Promise<PortfolioProperty> =>
    apiClient.patch<PortfolioProperty>(`/portfolio/${id}`, data),

  delete: (id: string): Promise<{ deleted: boolean }> =>
    apiClient.delete<{ deleted: boolean }>(`/portfolio/${id}`),

  // ─── Simulations ───────────────────────────────────────────────────────────

  getSimulations: (propertyId: string): Promise<PortfolioSimulation[]> =>
    apiClient.get<PortfolioSimulation[]>(`/portfolio/${propertyId}/simulations`),

  createSimulation: (
    propertyId: string,
    data: { name: string; parameters: SimulationParameters },
  ): Promise<PortfolioSimulation> =>
    apiClient.post<PortfolioSimulation>(`/portfolio/${propertyId}/simulations`, data),

  updateSimulation: (
    propertyId: string,
    simId: string,
    data: { name: string; parameters: SimulationParameters },
  ): Promise<PortfolioSimulation> =>
    apiClient.patch<PortfolioSimulation>(`/portfolio/${propertyId}/simulations/${simId}`, data),

  deleteSimulation: (propertyId: string, simId: string): Promise<{ deleted: boolean }> =>
    apiClient.delete<{ deleted: boolean }>(`/portfolio/${propertyId}/simulations/${simId}`),

  // ─── Simulations catalogue (liées aux annonces) ─────────────────────────────

  getCatalogSimulations: (propertyId: string): Promise<PortfolioSimulation[]> =>
    apiClient.get<PortfolioSimulation[]>(`/portfolio/catalog/${propertyId}/simulations`),

  createCatalogSimulation: (
    propertyId: string,
    data: { name: string; parameters: SimulationParameters },
  ): Promise<PortfolioSimulation> =>
    apiClient.post<PortfolioSimulation>(`/portfolio/catalog/${propertyId}/simulations`, data),

  updateCatalogSimulation: (
    propertyId: string,
    simId: string,
    data: { name: string; parameters: SimulationParameters },
  ): Promise<PortfolioSimulation> =>
    apiClient.patch<PortfolioSimulation>(`/portfolio/catalog/${propertyId}/simulations/${simId}`, data),

  deleteCatalogSimulation: (propertyId: string, simId: string): Promise<{ deleted: boolean }> =>
    apiClient.delete<{ deleted: boolean }>(`/portfolio/catalog/${propertyId}/simulations/${simId}`),
};
